// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"294":"3df3cb77","433":"3912f4f9","637":"bb90fecf","768":"c0b0a7de","886":"8c1f89f0"}[chunkId] + ".chunk.js";
};